/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockRecipeShareCtrl
 */
angular.module('mercury.modules.stock.recipe')
.controller('StockRecipeShareCtrl', ["companyId", "dialog", "$filter", "recipeIds", "$rootScope", "$scope", "StockSharedItems", "StockSharedRecipes", "userinfo", function(companyId, dialog, $filter, recipeIds, $rootScope, $scope, StockSharedItems, StockSharedRecipes, userinfo) {
  $scope.destinationCompanyId = null;

  var companies = userinfo.avaliableCompanies();

  if (companyId) {
    $scope.destinationCompanyId = companyId;

    $scope.loading = StockSharedRecipes.getSharePlan(recipeIds, $scope.destinationCompanyId);
    $scope.loading.then(function(result) {
      $scope.currentCompany = companies[userinfo.activeCompany()];
      $scope.shareCompany = companies[$scope.destinationCompanyId];

      $scope.itemsSharePlan = $filter('filter')(result, {type: 1});
      $scope.recipesSharePlan = $filter('filter')(result, {type: 0});
    });
  } else {
    $scope.companies = [];
    angular.forEach(companies, function(company) {
      if (company.id != userinfo.activeCompany()) {
        $scope.companies.push({id: company.id, name: company.name});
      }
    });
  }

  var isItemPlan = function(planStep) {
    return planStep.type == 1 || planStep.type == 2;
  };

  var isRecipePlan = function(planStep) {
    return planStep.type == 0 || planStep.type == 3;
  };

  $scope.siteSelected = function() {
    $scope.loading = StockSharedRecipes.getSharePlan(recipeIds, $scope.destinationCompanyId);
    $scope.loading.then(function(result) {
      $scope.currentCompany = companies[userinfo.activeCompany()];
      $scope.shareCompany = companies[$scope.destinationCompanyId];
      $scope.itemsSharePlan = $filter('filter')(result, isItemPlan);
      $scope.recipesSharePlan = $filter('filter')(result, isRecipePlan);
    });
  };

  $scope.confirmShare = function() {
    var fullSharePlan = $scope.itemsSharePlan.concat($scope.recipesSharePlan);
    $scope.sharingItem = StockSharedRecipes.executeSharePlan(fullSharePlan, $scope.destinationCompanyId);
    $scope.sharingItem.then(function() {
      angular.forEach($scope.recipesSharePlan, function(step) {
        $rootScope.$broadcast('manageSharedRecipeUpdated', {
          id: step.localId,
          isShared: true
        });
      });

      $scope.$close();

      if (recipeIds.length == 1) {
        dialog.open({
          templateUrl: 'modules/stock/recipe/manageshare.tpl.html',
          controller: 'StockRecipeManageShareCtrl',
          resolve: {
            recipeId: function() {
              return recipeIds[0];
            }
          }
        });
      }
    });
  };

  $scope.searchItems = function(searchStr) {
    return StockSharedItems.searchCompanyItems($scope.destinationCompanyId, searchStr);
  };

  $scope.searchRecipes = function(searchStr) {
    return StockSharedRecipes.searchCompanyRecipes($scope.destinationCompanyId, searchStr);
  };
}]);
